
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { mapGetters } from 'vuex'
import { go } from './libs/router'
import store from './vuex/store'
export default {
components: {
Tabbar,
TabbarItem,
Group,
Cell
},
computed: {
...mapGetters( ['isShowFooter'] )
},
methods: {
onShowMore () {
console.log( 'on click' )
},
onClick ( link ) {
go( link, this.$router )
},
showDialog () {
store.commit( 'UPDATE_SHOW_FOOTER', false )
this.showMore = true
},
dialogHide () {
store.commit( 'UPDATE_SHOW_FOOTER', true )
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue